import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '../themes/ThemeProvider';
export const Header = ({ title, rightContent, leftContent, className, style }) => {
    const theme = useTheme();
    return (_jsxs("header", { className: className, style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: theme['header-height'] ?? 64,
            padding: theme['header-padding'] ?? '0 24px',
            background: theme['header-background'] ?? '#fff',
            borderBottom: `1px solid ${theme['header-border-color'] ?? '#F2F2F2'}`,
            ...style,
        }, children: [_jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: theme.headerGap ?? 16,
                }, children: [leftContent, title && (_jsx("span", { style: {
                            fontWeight: theme.headerTitleWeight ?? 600,
                            fontSize: theme.headerTitleSize ?? 18,
                        }, children: title }))] }), _jsx("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: theme.headerGap ?? 16,
                }, children: rightContent })] }));
};
